import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import {PublicClientApplication} from "@azure/msal-browser";
import {authConfig} from './authConfig';
import {MsalProvider} from "@azure/msal-react";
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const pca = new PublicClientApplication(authConfig);

root.render(
  <MsalProvider instance={pca}>
      <BrowserRouter>
          <App></App>
      </BrowserRouter>
  </MsalProvider>
);

